import { render, staticRenderFns } from "./stockMovementItemsBox.vue?vue&type=template&id=79ff9410&"
import script from "./stockMovementItemsBox.vue?vue&type=script&lang=ts&"
export * from "./stockMovementItemsBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports